import React, { useState, useEffect } from "react";
import { Link } from "react-router-dom";
import CorkWallBlue from "../../assets/downloads/cork-wall-blue.jpg";
import Footer from "../../components/Footer";
import BrochureThumbnail from "../../assets/downloads/CM-Brochure-2023-thumbnail.avif";
import PressPackThumbnail from "../../assets/downloads/presspack-thumbnail.jpg";
import CorkGrades from "../../assets/downloads/Cork-grades.avif";
import LightingCover from "../../assets/downloads/Lighting-cover-26.avif";
import OrbCover from "../../assets/downloads/Orb-cover-26.avif";
import TablewareCover from "../../assets/downloads/Tableware-Cover-26.avif";
import WallCoverings26Cover from "../../assets/downloads/Wall-Coverings-cover-26.avif";
import WallCoveringsCover from "../../assets/downloads/Wall-Coverings-cover-24.avif";
import DropdownMenu from "../../components/DropdownMenu";
import SEO from "../../context/SEO";
import "./style.css";

import styles from "./style.module.scss";

function Downloads() {
  const [showElements, setShowElements] = useState("full-opacity");
  const vh = window.innerHeight * 0.01;

  const handleScroll = () => {
    const currentScrollPos = window.scrollY;

    if (
      currentScrollPos > -20 * vh &&
      currentScrollPos < 10 * vh &&
      showElements === "full-opacity"
    ) {
    } else if (currentScrollPos > -20 * vh && currentScrollPos < 10 * vh) {
      setShowElements("fade-in-up");
    } else {
      setShowElements("fade-out-up");
    }
  };

  useEffect(() => {
    window.addEventListener("scroll", handleScroll);
    return () => {
      window.removeEventListener("scroll", handleScroll);
    };
  }, [showElements]);

  return (
    <div>
      <DropdownMenu theme="dark-theme" showElements={showElements} />
      <SEO title="Cork Matters - Downloads" />
      <div className={styles.downloadsContainer}>
        <div className={styles.grid}>
          <Link
            className={styles.downloadCardFirst}
            to="https://drive.google.com/file/d/1x63KvnsyePetXn-j3rHMpKEJjhoUYXWk/view?usp=sharing"
          >
            <div className={styles.imageAndText}>
              <img
                src={LightingCover}
                alt="Cork Lighting Collection 26 catalogue"
              />
            </div>
          </Link>
          <Link
            className={styles.downloadCard}
            to="https://drive.google.com/file/d/1lOwFGAnnD1x3jR1hWEnhBupsuULRkt7R/view?usp=sharing"
          >
            <div className={styles.imageAndText}>
              <img
                src={WallCoverings26Cover}
                alt="Cork Wall Coverings 2026 catalogue"
              />
            </div>
          </Link>
          <Link
            className={styles.downloadCardFirst}
            to="https://drive.google.com/file/d/1MN_hzLQxXbbMTGbBVQmpYDT0DFGfZwkt/view?usp=sharing"
          >
            <div className={styles.imageAndText}>
              <img
                src={TablewareCover}
                alt="Cork Tableware Collection 26 catalogue"
              />
            </div>
          </Link>
          <Link
            className={styles.downloadCard}
            to="https://drive.google.com/file/d/1WtAChXU3ns2AxgJCxgLJPgluntYqmXgO/view?usp=sharing"
          >
            <div className={styles.imageAndText}>
              <img src={OrbCover} alt="Cork ORB Collection 26 catalogue" />
            </div>
          </Link>
          {/* <Link
            className={styles.downloadCardFirst}
            to="https://drive.google.com/file/d/1Zntlvp2Jo7rcwHyC1Wx3uDiR0WwJHI3J/view?usp=share_link"
          >
            <div className={styles.imageAndText}>
              <img
                src={WallCoveringsCover}
                alt="Cork Wall Coverings 2024 catalogue"
              />
            </div>
          </Link> */}
          {/* <Link
            className={styles.downloadCardFirst}
            to="https://drive.google.com/file/d/1LxZiO5Fi3xT4My58z3jO2gNP67orOwa8/view?usp=sharing"
          >
            <div className={styles.imageAndText}>
              <img src={BrochureThumbnail} alt="Brochure download link" />
            </div>
          </Link>
          <Link
            className={styles.downloadCard}
            to="https://drive.google.com/file/d/1LxZiO5Fi3xT4My58z3jO2gNP67orOwa8/view?usp=sharing"
          >
            <div className={styles.imageAndText}>
              <img src={PressPackThumbnail} alt="Alzira Peixoto" />
              <p className={styles.imageCaptionTop}>Press Pack</p>
            </div>
          </Link>
          <Link
            className={styles.downloadCardFirst}
            to="https://drive.google.com/file/d/1LxZiO5Fi3xT4My58z3jO2gNP67orOwa8/view?usp=sharing"
          >
            <div className={styles.imageAndText}>
              <img src={CorkGrades} alt="Story of Cork" />
              <p className={styles.imageCaptionTopRight}>Story of Cork</p>
            </div>
          </Link>
          <Link
            className={styles.downloadCard}
            to="https://drive.google.com/file/d/1LxZiO5Fi3xT4My58z3jO2gNP67orOwa8/view?usp=sharing"
          >
            <div className={styles.imageAndText}>
              <img src={CorkWallBlue} alt="Wall Coverings" />
              <p className={styles.imageCaptionTop}>Wall Coverings</p>
            </div>
          </Link> */}
        </div>
      </div>
      <Footer />
    </div>
  );
}

export default Downloads;
